/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchRunResultArtifactsStatementsInner
 */
export interface BatchRunResultArtifactsStatementsInner {
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultArtifactsStatementsInner
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultArtifactsStatementsInner
     */
    s3ObjectPath: string;
    /**
     * 
     * @type {string}
     * @memberof BatchRunResultArtifactsStatementsInner
     */
    documentNo: string;
}

/**
 * Check if a given object implements the BatchRunResultArtifactsStatementsInner interface.
 */
export function instanceOfBatchRunResultArtifactsStatementsInner(value: object): value is BatchRunResultArtifactsStatementsInner {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('s3ObjectPath' in value) || value['s3ObjectPath'] === undefined) return false;
    if (!('documentNo' in value) || value['documentNo'] === undefined) return false;
    return true;
}

export function BatchRunResultArtifactsStatementsInnerFromJSON(json: any): BatchRunResultArtifactsStatementsInner {
    return BatchRunResultArtifactsStatementsInnerFromJSONTyped(json, false);
}

export function BatchRunResultArtifactsStatementsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultArtifactsStatementsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        's3ObjectPath': json['s3_object_path'],
        'documentNo': json['document_no'],
    };
}

export function BatchRunResultArtifactsStatementsInnerToJSON(json: any): BatchRunResultArtifactsStatementsInner {
    return BatchRunResultArtifactsStatementsInnerToJSONTyped(json, false);
}

export function BatchRunResultArtifactsStatementsInnerToJSONTyped(value?: BatchRunResultArtifactsStatementsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        's3_object_path': value['s3ObjectPath'],
        'document_no': value['documentNo'],
    };
}

